import React from "react";
import { useNavigate } from "react-router-dom";
import { createBookingCommission, getBookingTypes } from "adminApi/BookingCommissionApi/BookingCommission";
import { BookingCommissionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddBookingCommissionForm from "./Components/AddBookingCommissionForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/BookingCommissionFields.json";
import useFetchAllData from "Hooks/useFetchAllData";

const AddBookingCommission = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, BookingCommissionRules);

    // Fetch booking types for the select dropdown
    const { data: bookingTypeOptions, loading: loadingTypes } = useFetchAllData(getBookingTypes);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await createBookingCommission(formValues),
        (vals) => {
            const err = validateForm(vals, BookingCommissionRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Booking Commission Created Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingTypes) && <Spinner isSpinner={true} />}
            <AddBookingCommissionForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                bookingTypeOptions={bookingTypeOptions || []}
            />
        </>
    );
};

export default AddBookingCommission;
